__webpack_public_path__ = `${window.location.origin}/`;

if (process.env.NODE_ENV !== 'production') {
  __webpack_public_path__ = 'http://localhost:3000/';
}
import('./bootstrap');
export {};
